import { Grid, Paper, Tab, Tabs } from "@mui/material";
import useJobTabs from "../hooks/useJobTabs";
import TabLabel from "components/pages/transmissions/tabs/label/TabLabel";

const JobTabs = ({ role, selectedTab, tabStyles, setSelectedTab }) => {
  const { tabs, onTabChange } = useJobTabs(role, tabStyles, setSelectedTab);

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          {selectedTab && (
            <Paper
              square
              elevation={0}
              style={{
                position: "relative",
                top: "1px",
                zIndex: 1000,
                backgroundColor: "transparent",
              }}
            >
              <Tabs
                onChange={(_event, value) => {
                  onTabChange(value);
                }}
                value={selectedTab}
                indicatorColor="secondary"
                TabIndicatorProps={{
                  style: { top: 0, borderBottom: "none" },
                }}
                textColor="secondary"
              >
                {tabs.map(({ label, value, style }, index) => (
                  <Tab
                    key={index}
                    disabled={false}
                    style={style}
                    value={value}
                    sx={{ fullWidth: true }}
                    label={<TabLabel label={label} count={0} />}
                  />
                ))}
              </Tabs>
            </Paper>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default JobTabs;
